import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { NewWatcherEntityQueryParams } from '../../watchers.types';
import {
  deleteUserWatcher,
  removeWatcherFromList,
  addNewWatcherToList,
  createUserWatcher,
} from '../../state/actions';
import {
  sendWatcherCreatedEvent,
  sendWatcherDeletedEvent,
} from '../../WatchersUtils';
import { StateType } from '../../../state/state.types';

const mapState = (
  { userWatchers }: StateType,
  { uniqueId }: { uniqueId: string },
) => ({
  isWatched: userWatchers.uniquesIds.includes(uniqueId),
});

const mapDispatch = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
  async createUserWatcher(
    queryParams: NewWatcherEntityQueryParams,
    uniqueId: string,
    source: string,
  ) {
    const watcherData = await dispatch(
      createUserWatcher(queryParams, uniqueId),
    );
    sendWatcherCreatedEvent({
      key: watcherData.key,
      source,
      reportOriginalQueryKey: true,
    });

    if (!watcherData.alreadyExists) {
      const { q, ...queryParamsId } = queryParams;

      await dispatch(
        addNewWatcherToList({
          key: watcherData.key,
          searchQuery: {
            query: queryParams.q,
            ...queryParamsId,
          },
        }),
      );
    }
  },
  async deleteUserWatcher(uniqueId: string, source: string) {
    const watcherKey = await dispatch(deleteUserWatcher(uniqueId));
    await dispatch(removeWatcherFromList(watcherKey));
    sendWatcherDeletedEvent({
      key: watcherKey,
      source,
    });
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
